export default {
  machines: [],
  machine: {}
}